import { render, staticRenderFns } from "./Cod.vue?vue&type=template&id=347e25f4&scoped=true"
import script from "./Cod.vue?vue&type=script&lang=js"
export * from "./Cod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e25f4",
  null
  
)

export default component.exports